/**
 * The comments feature's main entry point: the thread, the composer and the
 * hooks other features render with. Comment types and pure functions come
 * from `@/features/comments/model`, and the thread's query options and seed
 * from `@/features/comments/api`, for another feature's adapter; never from
 * here, so each name has one public home.
 *
 * Inside the feature, dependencies point inward: `ui` uses `hooks` and
 * `model`; `hooks` use `api`, `ports` and `model`; `api` implements `ports`
 * and maps wire shapes to `model`; `ports` use `model`; `model` imports
 * nothing from the feature or any framework.
 */
export { useComments } from './hooks/useComments';

export { useCreateComment } from './hooks/useCreateComment';

export { Comments } from './ui/thread/Comments';

export { CommentBox, type CommentBoxHandle } from './ui/composer/CommentBox';
